import { all } from 'redux-saga/effects';

import { requestSagas } from '../slices';

function* slicesRequestsSaga() {
  yield all(requestSagas);
}

export default slicesRequestsSaga;
